import { useEffect, useState } from 'react';

/** Animate 0 → pct over duration ms (easeOut). */
export function useProgressRing(percent, duration = 1000, enabled = true) {
  const [value, setValue] = useState(0);

  useEffect(() => {
    const end = Math.min(100, Math.max(0, Number(percent) || 0));
    if (!enabled) {
      setValue(end);
      return undefined;
    }
    const reducedMotion =
      typeof window !== 'undefined' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) {
      setValue(end);
      return undefined;
    }
    const t0 = performance.now();
    let frameId;

    const tick = (now) => {
      const p = Math.min(1, (now - t0) / duration);
      const eased = 1 - (1 - p) ** 3;
      setValue(end * eased);
      if (p < 1) frameId = requestAnimationFrame(tick);
    };

    frameId = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frameId);
  }, [percent, duration, enabled]);

  return value;
}

export default useProgressRing;
